import { TriangleDownIcon } from "@chakra-ui/icons";
import { Flex, Tooltip } from "@chakra-ui/react";
import { Marker as MapboxMarker } from "react-map-gl";
import { NavigationVoiceAndCoordinate } from "~/generated/graphql.types";

export const NavigationVoiceMarker = ({
  navigationVoiceSpot,
}: {
  navigationVoiceSpot: NavigationVoiceAndCoordinate;
}) => {
  return (
    <MapboxMarker
      latitude={navigationVoiceSpot.coordinate.lat}
      longitude={navigationVoiceSpot.coordinate.lon}
    >
      <Tooltip hasArrow label={navigationVoiceSpot.navigationVoice}>
        <Flex
          w={4}
          h={4}
          rounded="full"
          bgColor={"green.400"}
          borderWidth={5}
          borderColor="green.300"
          justifyContent="center"
        >
          <TriangleDownIcon
            position="absolute"
            zIndex={-1}
            bottom={-2}
            color={"green.400"}
            fontSize={16}
          />
        </Flex>
      </Tooltip>
    </MapboxMarker>
  );
};
